import { css } from "styled-components";

const variables = css`
  :root {
    --dark-bg: #000;
    /* --gray-1:#bcb4b4 ; */
    --gray-1: #d0c8c8;
    --deep-dark: #000;
    --gray-2: #363636;
    --white: white;
    --black: black;
    --gradient: linear-gradient(to bottom right, red, yellow);
    --font-xsm: 1.5rem;
    --font-sm: 1.75rem;
    --font-bg: 3rem;
    --font-m: 2rem;
    --font-h2: 4.5;
  }
`;

export default variables;
